export const REGEX_WHITESPACES = /\s/g;
export const REGEX_NUMBERS = /(\d+)/g;
export const REGEX_NOT_PHONE_NUMBER = /[a-z]|[а-я]|["'№;:?!@#$%^&*(){}=-_\\/]/g;
export const REGEX_VALID_EMAIL = /^[\w-._+-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const REGEX_URL_NAME = /^((http[s]?|ftp):\/)?\/?([^:/\s]+)?/;

export const MO_CARD_PIN_CODE_LENGTH = 4;
export const REGISTRATION_EMAIL_CODE_LENGTH = 5;
export const RESTORE_PASSWORD_SMS_CODE_LENGTH = 4;

export const REGISTRATION_EMAIL_CODE_EXPIRATION_TIME = 15;
export const RESTORE_PASSWORD_SMS_CODE_EXPIRATION_TIME = 5;

export const YEARS_RANGE = 100;
export const COUNT_MONTH = 12;

export const DEFAULT_LANGUAGE = 'ru';
export const ALLOWED_LOCALES = ['ru', 'en', 'cn'];

export const WEAK_PASSWORD = 'weak';
export const MEDIUM_PASSWORD = 'medium';
export const STRONG_PASSWORD = 'strong';

export const IS_PUBLIC_ACCESS_RESTRICTED_KEY = 'IS_PUBLIC_ACCESS_RESTRICTED';
export const IS_PUBLIC_ACCESS_RESTRICTED = process.env.VUE_APP_IS_PUBLIC_ACCESS_RESTRICTED === 'true';

export const ALLOWED_COOKIE_NITICE_TYPES = ['all', 'necessary'];
export const ONE_YEAR = 31536000;
